/**
 * 10.9EO — AGENDA DA RAID (horarios fixos em hora de Brasilia). Mesma regra do servidor
 * (server/raid): slot "AAAA-MM-DD-HH", Brasil = UTC-3 (sem horario de verao desde 2019).
 * O servidor e quem manda; isto serve pro HUD mostrar a contagem e o botao na hora certa.
 */
import { GameConfig } from "../config/GameConfig";

const BRT_OFFSET_H = -3;

export interface RaidSlot {
  slot: string;
  lobby: number; // a partir daqui ja da pra entrar (o boss ainda dorme)
  start: number; // o boss acorda
  end: number; // acabou o tempo
}

function slotAt(dayUtcMs: number, hourBrt: number): RaidSlot {
  const d = new Date(dayUtcMs);
  const y = d.getUTCFullYear();
  const m = d.getUTCMonth();
  const dd = d.getUTCDate();
  const start = Date.UTC(y, m, dd, hourBrt - BRT_OFFSET_H);
  const c = GameConfig.raid;
  const pad = (n: number): string => String(n).padStart(2, "0");
  return {
    slot: `${y}-${pad(m + 1)}-${pad(dd)}-${pad(hourBrt)}`,
    lobby: start - c.lobbyMin * 60_000,
    start,
    end: start + c.windowMin * 60_000,
  };
}

/** A raid que ainda nao acabou mais proxima de `now` (a de agora, se estiver rolando). */
export function nextRaid(now = Date.now()): RaidSlot {
  // "hoje" no calendario de Brasilia
  const brt = new Date(now + BRT_OFFSET_H * 3600_000);
  const today = Date.UTC(brt.getUTCFullYear(), brt.getUTCMonth(), brt.getUTCDate());
  const hours = [...GameConfig.raid.hoursBRT].sort((a, b) => a - b);
  for (let day = 0; day < 3; day++) {
    for (const h of hours) {
      const s = slotAt(today + day * 86_400_000, h);
      if (s.end > now) return s;
    }
  }
  return slotAt(today + 86_400_000, hours[0]);
}

export function fmtCountdown(ms: number): string {
  const t = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(t / 3600);
  const m = Math.floor((t % 3600) / 60);
  const s = t % 60;
  return h > 0 ? `${h}h${String(m).padStart(2, "0")}` : `${m}:${String(s).padStart(2, "0")}`;
}
